import { PaymentTerm } from '../../entities/control-tables/payment-term';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class PaymentTermRequest extends BaseRequest {

    paymentTerm : PaymentTerm

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.paymentTerm = new PaymentTerm()
  }
}